export default __webpack_public_path__ + "static/media/notfound.604bae9f.png";